// Utility functions for route permission checks (additive; no existing code removed)

const normalizePath = (path = '') => {
  // Remove trailing slashes and param segments like :id
  return path.replace(/\/+$/, '').replace(/\/:.*$/, '');
};

// Normalize module names for comparison (handles spaces, case, special chars)
const normalizeModuleName = (name = '') => {
  if (!name) return '';
  // Convert to lowercase, remove spaces, hyphens, underscores
  return name.toLowerCase()
    .replace(/\s+/g, '')  // Remove all spaces
    .replace(/-/g, '')    // Remove hyphens
    .replace(/_/g, '');   // Remove underscores
};

export const getRouteType = (routePath = '', routeName = '') => {
  const path = routePath.toLowerCase();
  const name = (routeName || '').toLowerCase();
  if (path.includes('/add') || name.includes('-add')) return 'add';
  if (path.includes('/edit') || name.includes('-edit')) return 'edit';
  if (path.includes('/view') || name.includes('-view')) return 'view';
  return 'listing';
};

export const matchRouteToModule = (routePath = '', modules = []) => {
  const normalizedTarget = normalizePath(routePath);
  let matched = null;

  modules.forEach(mod => {
    if (matched || !mod || !Array.isArray(mod.routes)) return;
    const hasRoute = mod.routes.some(r => {
      if (!r || !r.route) return false;
      return normalizePath(r.route) === normalizedTarget || normalizedTarget.startsWith(normalizePath(r.route));
    });
    if (hasRoute) matched = mod;
  });

  // Fallback: prefix match by module url/name if route field absent
  if (!matched) {
    modules.forEach(mod => {
      if (matched || !mod || !mod.url) return;
      if (normalizedTarget.startsWith(normalizePath(mod.url))) matched = mod;
    });
  }

  return matched;
};

export const hasAnyModulePermission = rights => {
  return rights && (rights.add === 1 || rights.edit === 1 || rights.view === 1 || rights.delete === 1);
};

export const checkUserRoutePermission = (userRights = [], moduleName = '', routeType = 'listing') => {
  if (!moduleName) return false;
  const normalizedSearchName = normalizeModuleName(moduleName);
  
  // Try exact match first (case-insensitive)
  let rights = (userRights || []).find(r => {
    const modName = (r.modulename || '').toLowerCase();
    return modName === moduleName.toLowerCase();
  });
  
  // Try normalized match (handles spaces, hyphens, etc.)
  if (!rights) {
    rights = (userRights || []).find(r => {
      const modName = normalizeModuleName(r.modulename || '');
      return modName === normalizedSearchName;
    });
  }
  
  // Try partial match (e.g., "Site Visit" matches "sitevisit")
  if (!rights) {
    rights = (userRights || []).find(r => {
      const modName = normalizeModuleName(r.modulename || '');
      return modName.includes(normalizedSearchName) || normalizedSearchName.includes(modName);
    });
  }
  
  if (!rights) return false;

  switch (routeType) {
    case 'add':
      return rights.add === 1;
    case 'edit':
      return rights.edit === 1;
    case 'view':
      return rights.view === 1;
    case 'listing':
    default:
      return hasAnyModulePermission(rights);
  }
};

export { normalizeModuleName };

export default {
  getRouteType,
  matchRouteToModule,
  checkUserRoutePermission,
  hasAnyModulePermission,
  normalizeModuleName,
};

